export default "__VITE_ASSET__Bz6ZfL$n__"